<template>
  <div>
    <Transition>
      <TNotification
        v-if="notification || persistentNotification"
        :clickable="true"
        @click="handleNotificationClick"
      />
    </Transition>
    <TMenuBar :items="items" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TMenuBar from '@/legacy/nashville/menu/TMenuBar.vue'
import TNotification from '@/legacy/nashville/TNotification.vue'
import { setup } from './controller'

export default defineComponent({
  components: {
    TMenuBar,
    TNotification,
  },
  setup,
})
</script>

<style lang="scss" scoped>
@media print {
  .print-hidden {
    display: none !important;
  }
}
</style>
